module.exports = __webpack_public_path__ + "img/squig1.e67c0d0.png";